var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav'),_c('banner-part',{attrs:{"bannerInfo":_vm.bannerInfo}}),_c('div',{staticClass:"container"}),_c('Footer',{staticClass:"top"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }